import script from "./RoamingInfoDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoamingInfoDetails.vue?vue&type=script&setup=true&lang=ts"

import "./RoamingInfoDetails.vue?vue&type=style&index=0&id=10f24099&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f24099"]])

export default __exports__